( function( $, document, window ) {
	'use strict';

	$( function() {
		const swiper = new Swiper('.js-card-carousel', {
			direction: 'horizontal',
			spaceBetween: 20,
			slidesPerView: 'auto',
			loop: true,

			navigation: {
				nextEl: '.js-carousel-nav-next',
				prevEl: '.js-carousel-nav-prev',
			},

			breakpoints: {
				768: {
					spaceBetween: 30,
				},

				1024: {
					spaceBetween: 40,
				}
			},

			on: {
				beforeInit: function () {
					let numSlides = this.wrapperEl.querySelectorAll( '.js-carousel-slide' ).length;
					if ( numSlides <= 4 ) {
						this.params.loop = false;
					}
				}
			}
		});
	} );
} )( jQuery, document, window );
